import { Features } from '/@utilities/features';
import { downloadFile } from '/@utilities/files';
import http from '/@utilities/http';

export type ExportFeatures = Features.InnsiktTimerApproveView | Features.InnsiktTimerScheduleView;

export type Reports = {
  Name: string;
  Guid: string;
  Extension: string;
}[];

export async function downloadReport(fileName: string) {
  const d = new Date();

  let fullName = fileName;
  fullName += `_${d.getFullYear()}-${d.getMonth() + 1}-${d.getUTCDate()}`;
  fullName += `_${d.getHours()}-${d.getMinutes()}`;

  return downloadFile('/innsikt/reports/dcc98d6d-bcd5-4fe2-bdc5-e24cfc1d89ee/download', fullName);
}

export async function getInnsiktAppFeatureReports(appFeature: ExportFeatures) {
  const url = `/Innsikt/AppFeatures/${appFeature}/Reports`;
  return http.get<Reports>(url).then(({ data }) => data);
}
